import React from "react";
import {
  LineChart as ReLineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface LineChartProps {
  data: any[];
  dataKey: string;
  xKey: string;
  lineColor?: string;
  height?: string;
}

const CustomLineChart: React.FC<LineChartProps> = ({
  data,
  dataKey,
  xKey,
  lineColor = "#3B82F6",
  height = "h-[28rem]",
}) => (
  <div className={`w-full flex items-center justify-center relative ${height}`}>
    <ResponsiveContainer width="100%" height="100%">
      <ReLineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
        <XAxis
          dataKey={xKey}
          stroke="#6B7280"
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          stroke="#6B7280"
          fontSize={12}
          tickLine={false}
          axisLine={false}
        />
        <Tooltip />
        <Line
          type="monotone"
          dataKey={dataKey}
          stroke={lineColor}
          strokeWidth={3}
          dot={{ fill: lineColor, strokeWidth: 2, r: 4 }}
          activeDot={{
            r: 6,
            stroke: lineColor,
            strokeWidth: 2,
          }}
        />
      </ReLineChart>
    </ResponsiveContainer>
  </div>
);

export default CustomLineChart;
